export default __webpack_public_path__ + "static/media/send_btn.31a01c74.svg";